module.exports = __webpack_public_path__ + "img/2025-11-17c_9.f9665a6a.jpg";